import type { PhoneNumberFormSchema } from '@/_schemas/phone-numbers';

import { typesOptions } from './type-options';

export const defaultValues: Readonly<PhoneNumberFormSchema> = {
  number: '+1 (###) ###-####',
  type: typesOptions[4],
  country: {
    id: -1,
    name: '',
    short_name: null,
    capital_city: null,
    calling_code: '1',
    phone_format: '(###) ###-####',
    status: '',
    abbreviation: null,
    flag_id: null,
    flag: null,
    continent_abbreviation: null,
    currency_name: null,
    continent_name: null,
    tld: null,
  },
  isDuplicate: false,
} as const;
